import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';

// context
import { AppProvider } from '../app/app.provider';
import { SocketProvider } from '../socket/socket.provider';
import { ToasterProvider } from '../toaster/toaster.provider';

// componenets
import ToasterMessages from '../toaster/toaster-messages';

import { queryClient } from '#/app/app.queryClient';
import AblyRealtime from '../components/AblyRealtime';
import GlobalModal from '../components/GlobalModal';
import UpdateChaportUserDetails from '../components/UpdateChaportUserDetails';
import { WebLayout } from '../components/WebLayout/WebLayout';
import Navigation from '../navigation/navigation';
import AuthProvider from '../screens/auth/auth.provider';
import './app.styles.scss';

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ReactQueryDevtools initialIsOpen={false} />
    <ToasterProvider>
      <AppProvider>
        <AuthProvider>
          <SocketProvider>
            <WebLayout>
              <Navigation />
              <ToasterMessages />
            </WebLayout>
            <UpdateChaportUserDetails />
            <AblyRealtime />
            <GlobalModal />
          </SocketProvider>
        </AuthProvider>
      </AppProvider>
    </ToasterProvider>
  </QueryClientProvider>
);

export default App;
